export const sectionExperiments = {
  headerSectionAddVisibilityTransition:
    'specs.thunderbolt.HeaderSectionAddVisibilityTransition',
  headerUseMargins: 'specs.thunderbolt.headerUseMargins',
};
